/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	ResearchProposalDTO,
	ResearchProposalDTOFromJSON,
	ResearchProposalDTOFromJSONTyped,
	ResearchProposalDTOToJSON,
} from "./ResearchProposalDTO";

/**
 *
 * @export
 * @interface ResearchProposalDTOPagedResponse
 */
export interface ResearchProposalDTOPagedResponse {
	/**
	 *
	 * @type {number}
	 * @memberof ResearchProposalDTOPagedResponse
	 */
	page?: number;
	/**
	 *
	 * @type {number}
	 * @memberof ResearchProposalDTOPagedResponse
	 */
	pageSize?: number;
	/**
	 *
	 * @type {number}
	 * @memberof ResearchProposalDTOPagedResponse
	 */
	totalCount?: number;
	/**
	 *
	 * @type {Array<ResearchProposalDTO>}
	 * @memberof ResearchProposalDTOPagedResponse
	 */
	data?: Array<ResearchProposalDTO> | null;
}

export function ResearchProposalDTOPagedResponseFromJSON(
	json: any
): ResearchProposalDTOPagedResponse {
	return ResearchProposalDTOPagedResponseFromJSONTyped(json, false);
}

export function ResearchProposalDTOPagedResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): ResearchProposalDTOPagedResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		page: !exists(json, "page") ? undefined : json["page"],
		pageSize: !exists(json, "pageSize") ? undefined : json["pageSize"],
		totalCount: !exists(json, "totalCount") ? undefined : json["totalCount"],
		data: !exists(json, "data")
			? undefined
			: json["data"] === null
			? null
			: (json["data"] as Array<any>).map(ResearchProposalDTOFromJSON),
	};
}

export function ResearchProposalDTOPagedResponseToJSON(
	value?: ResearchProposalDTOPagedResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		page: value.page,
		pageSize: value.pageSize,
		totalCount: value.totalCount,
		data:
			value.data === undefined
				? undefined
				: value.data === null
				? null
				: (value.data as Array<any>).map(ResearchProposalDTOToJSON),
	};
}
